<!--
  @component HomeCanvas — renders the Projects-home block layout.
  tier:      home layout
  purpose:   a 12-column grid that places each block by its span (full=12,
             main=8, side=4) and renders it via the kind→component registry.
             Adding a block kind = one registry entry + one layout spec.
             (config is carried on the spec for the future per-block seam;
             v1 blocks read their own data via the global IO hooks.)
-->
<script lang="ts">
  import type { Component } from "svelte";
  import {
    DEFAULT_HOME_LAYOUT,
    SPAN_COLS,
    type HomeBlockKind,
    type HomeBlockSpec,
  } from "./home-blocks.js";
  import HeroBlock from "./blocks/HeroBlock.svelte";
  import StatStripBlock from "./blocks/StatStripBlock.svelte";
  import ProjectCarouselBlock from "./blocks/ProjectCarouselBlock.svelte";
  import ActivityFeedBlock from "./blocks/ActivityFeedBlock.svelte";
  import ScheduleBlock from "./blocks/ScheduleBlock.svelte";
  import ProjectGridBlock from "./blocks/ProjectGridBlock.svelte";

  interface Props { blocks?: readonly HomeBlockSpec[]; }
  const { blocks = DEFAULT_HOME_LAYOUT }: Props = $props();

  const REGISTRY: Record<HomeBlockKind, Component> = {
    "hero": HeroBlock,
    "stat-strip": StatStripBlock,
    "project-carousel": ProjectCarouselBlock,
    "activity-feed": ActivityFeedBlock,
    "schedule": ScheduleBlock,
    "project-grid": ProjectGridBlock,
  };
</script>

<div class="canvas">
  {#each blocks as b (b.id)}
    {@const Cmp = REGISTRY[b.kind]}
    {#if Cmp}
      <div class="slot" style:grid-column={`span ${SPAN_COLS[b.span]}`}>
        <Cmp />
      </div>
    {/if}
  {/each}
</div>

<style>
  .canvas {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: var(--space-5);
    align-items: stretch;
  }
  .slot { min-width: 0; }
  @media (max-width: 900px) {
    .slot { grid-column: span 12 !important; }
  }
</style>
